var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/danger"
  }, /*#__PURE__*/React.createElement("g", {
    id: "danger"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M54.4002 39.8L38.4002 11C36.2502 7.125 33.2752 5 30.0002 5C26.7252 5 23.7502 7.125 21.6002 11L5.60019 39.8C3.57519 43.475 3.35019 47 4.97519 49.775C6.60019 52.55 9.80019 54.075 14.0002 54.075H46.0002C50.2002 54.075 53.4002 52.55 55.0252 49.775C56.6502 47 56.4252 43.45 54.4002 39.8ZM28.1252 22.5C28.1252 21.475 28.9752 20.625 30.0002 20.625C31.0252 20.625 31.8752 21.475 31.8752 22.5V35C31.8752 36.025 31.0252 36.875 30.0002 36.875C28.9752 36.875 28.1252 36.025 28.1252 35V22.5ZM31.7752 44.275C31.6502 44.375 31.5252 44.475 31.4002 44.575C31.2502 44.675 31.1002 44.75 30.9502 44.8C30.8002 44.875 30.6502 44.925 30.4752 44.95C30.3252 44.975 30.1502 45 30.0002 45C29.8502 45 29.6752 44.975 29.5002 44.95C29.3502 44.925 29.2002 44.875 29.0502 44.8C28.9002 44.75 28.7502 44.675 28.6002 44.575C28.4752 44.475 28.3502 44.375 28.2252 44.275C27.7752 43.8 27.5002 43.15 27.5002 42.5C27.5002 41.85 27.7752 41.2 28.2252 40.725C28.3502 40.625 28.4752 40.525 28.6002 40.425C28.7502 40.325 28.9002 40.25 29.0502 40.2C29.2002 40.125 29.3502 40.075 29.5002 40.05C29.8252 39.975 30.1752 39.975 30.4752 40.05C30.6502 40.075 30.8002 40.125 30.9502 40.2C31.1002 40.25 31.2502 40.325 31.4002 40.425C31.5252 40.525 31.6502 40.625 31.7752 40.725C32.2252 41.2 32.5002 41.85 32.5002 42.5C32.5002 43.15 32.2252 43.8 31.7752 44.275Z",
    fill: "#D43338"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/danger.79b34edfd65da3961416ffd3e99bd92d.svg";
export { ForwardRef as ReactComponent };